export function normalizeTagName(value) {
  return typeof value === 'string' ? value.trim() : '';
}

export function normalizeTagNames(value) {
  return Array.from(new Set((Array.isArray(value) ? value : [])
    .map(normalizeTagName)
    .filter(Boolean)));
}

export function getPricingTagNames(setup = {}) {
  return new Set([
    ...Object.keys(setup?.tagOverrides || {}),
    ...Object.keys(setup?.tagOverridesYearly || {}),
    ...Object.keys(setup?.subscriptions?.tagOverrides || {}),
    ...Object.keys(setup?.subscriptions?.tagOverridesYearly || {}),
  ].map(normalizeTagName).filter(Boolean));
}

export function buildRequiredTagGroups(teamTags = [], { pricingTagNames = new Set() } = {}) {
  const grouped = new Map();

  (Array.isArray(teamTags) ? teamTags : []).forEach((tag) => {
    if (!tag || tag.type === 'ageRule') return;
    if (tag.requiredForMembers !== true) return;
    if (tag.visibleToMembers === false || tag.selfAssignable !== true) return;

    const name = normalizeTagName(tag.name);
    if (!name) return;
    const category = normalizeTagName(tag.category) || 'Uncategorised';
    if (!grouped.has(category)) {
      grouped.set(category, {
        category,
        multiAssignable: Boolean(tag.multiAssignable),
        requiredForMembers: true,
        isPricingGroup: false,
        tags: [],
      });
    }

    const group = grouped.get(category);
    group.multiAssignable = group.multiAssignable || Boolean(tag.multiAssignable);
    group.isPricingGroup = group.isPricingGroup || pricingTagNames.has(name);
    if (!group.tags.includes(name)) group.tags.push(name);
  });

  return Array.from(grouped.values())
    .map((group) => ({
      ...group,
      tags: group.tags.sort((a, b) => a.localeCompare(b)),
    }))
    .sort((a, b) => a.category.localeCompare(b.category));
}

export function getMissingRequiredTagGroups(requiredGroups = [], selectedTagNames = [], { includePricing = true } = {}) {
  const selected = new Set(normalizeTagNames(selectedTagNames));
  return (Array.isArray(requiredGroups) ? requiredGroups : [])
    .filter((group) => includePricing || group.isPricingGroup !== true)
    .filter((group) => !normalizeTagNames(group.tags).some((tagName) => selected.has(tagName)));
}
